import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiDatabase, FiLayers, FiPackage, FiTool } = FiIcons;

const DatabaseStats = ({ products, categories }) => {
  const stats = [
    {
      title: 'Gesamtprodukte',
      value: products.length.toLocaleString('de-DE'),
      subtitle: 'Technische Komponenten',
      icon: FiDatabase,
      color: 'bg-black'
    },
    {
      title: 'Produktkategorien',
      value: categories.length,
      subtitle: 'ETIM-Klassifikationen',
      icon: FiLayers,
      color: 'bg-red-600'
    },
    {
      title: 'Wälzlager',
      value: products.filter(p => p.etim_class_code.startsWith('EC0000')).length,
      subtitle: 'Verschiedene Lagertypen',
      icon: FiPackage,
      color: 'bg-gray-800'
    },
    {
      title: 'Dichtungen',
      value: products.filter(p => p.etim_class_code === 'EC002306').length,
      subtitle: 'Abdichtungslösungen',
      icon: FiTool,
      color: 'bg-red-800'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.title}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          whileHover={{ scale: 1.02 }}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">{stat.title}</p>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              <p className="text-xs text-gray-500 mt-1">{stat.subtitle}</p>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat.color} flex items-center justify-center shadow-sm`}>
              <SafeIcon icon={stat.icon} className="w-6 h-6 text-white" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default DatabaseStats;